import { CustomerType, customerTypeSchema } from "./CustomerType";
import { AddressValue } from "../core/AddressValue";
import * as zod from "zod";
import { StringUtils } from "$lib/stringUtils";
import { GeoLocation } from "../projects/ProjectDetail";
import { Contact, contactSchema } from "./Contact";

export interface Customer {
  id: number;
  firstname: string;
  lastname: string;
  email?: string;

  vatNumber?: string;
  companyName?: string;

  phoneNumber1: string;

  billingAddress: AddressValue;
  customerType: CustomerType;
  billingAddressLocation?: GeoLocation;

  contacts: Contact[];
}

export const customerSchema = zod
  .object({
    customerType: customerTypeSchema,
    firstname: zod.string().optional().nullable(),
    lastname: zod.string().optional().nullable(),
    companyName: zod.string().optional().nullable(),
    vatNumber: zod.string().optional().nullable(),
    phoneNumber1: zod.string().min(1, "page.customers.labels.phoneNumber1-required"),
    email: zod
      .string()
      .email("page.customers.labels.email-validation")
      .optional(),
    contacts: contactSchema.array().optional().nullable()
  })
  .refine(
    (data) => {
      if (data.customerType && data.customerType.id > 1) {
        return !StringUtils.isNullOrEmpty(data.companyName);
      }
      return true;
    },
    {
      message: "page.customers.labels.companyName-required",
      path: ["companyName"],
    }
  )
  .refine(
    (data) => {
      if (data.customerType && data.customerType.id > 1) {
        return !StringUtils.isNullOrEmpty(data.vatNumber);
      }
      return true;
    },
    {
      message: "page.customers.labels.vatNumber-required",
      path: ["vatNumber"],
    }
  )
  .refine(
    (data) => {

      if (data.customerType && data.customerType.id == 1) {
        return !StringUtils.isNullOrEmpty(data.firstname);
      }
      return true;
    },
    {
      message: "page.customers.labels.firstname-required",
      path: ["firstname"],
    }
  )
  .refine(
    (data) => {
      if (data.customerType && data.customerType.id == 1) {
        return !StringUtils.isNullOrEmpty(data.lastname);
      }
      return true;
    },
    {
      message: "page.customers.labels.lastname-required",
      path: ["lastname"],
    }
  )
  .refine(
    (data) => {

      return data.customerType.id > 0;
    },
    {
      message: "page.customers.labels.customerTypeRequired",
      path: ["customerType"],
    }
  );
